import React, { useState } from 'react'
import MainDataContext from './PaymentDataContext';

export default function PaymentDataComponent({ children }) {

  const [paymentData, setPaymentData] = useState(null);

  return (
    <MainDataContext.Provider value={{ paymentData, setPaymentData }}>
      {children}
    </MainDataContext.Provider>
  )
}